"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M17.585 5h-2.949V3H21v6.364h-2v-2.95l-6.339 6.338-1.414-1.414L17.585 5z" }),
    React.createElement("path", { d: "M6.017 5.09C5.455 5.09 5 5.547 5 6.109v11.875C5 18.545 5.455 19 6.017 19h11.875c.562 0 1.017-.455 1.017-1.017v-5.938h2v5.938A3.017 3.017 0 0117.892 21H6.017A3.017 3.017 0 013 17.983V6.108A3.017 3.017 0 016.017 3.09h5.938v2H6.017z" })), "ExternalLink");
//# sourceMappingURL=ExternalLink.js.map